<script setup>
import '@/assets/cloudCounter/css/style.css';
import { computed, onMounted, ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import Process from '@/components/cloudCounter/Process.vue';
import { postCheckReserveDatetimePeriodApply } from '@/apis/CloudECounterReserve';
import { useRouter } from 'vue-router';
import { postCancelTransaction, postCecRecord } from '@/apis/record';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import Loading from '@/components/Loading.vue';
import { convertCaseBoxList } from '@/views/cloudECounter/reserve/record/caseBoxUtils';
import loanField from '@/views/cloudECounter/reserve/record/loanField';
import { useStore } from 'vuex';
import routeName from '@/router/constant';

const store = useStore();
const router = useRouter();
const goNextPage = () => {
    if (!canVideo.value) {
        return;
    }
    isLoading.value = true;
    postCheckReserveDatetimePeriodApply().then(res => {
        router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_VIDEO });
        isLoading.value = false;
    }).catch(ex => {
        openPopupCatchMessage(ex);
        isLoading.value = false;
    }).finally(() => {
        // isLoading.value = false;
    });
};
const regiNo = computed(() => store.state.permissions.userInfo?.reserveVideo?.regiNo);
const endoresStatus = computed(() => endoresmentContent.value.boxList[0].list[0].value == null || endoresmentContent.value.boxList[0].list[0].value.length <= 1 );

const isLoading = ref(true);
const record = ref({
    boxList: [{ list: [] }],
});
const accountInfo = ref(null);

const moneyInfo = ref(null);
const caseItemList = ref(null);
const canCancel = ref(false);
const canVideo = ref(false);

caseItemList.value = [];

const endoresmentContent = ref({
    boxList: [{
        title: '本次變更批註寄送方式',
        list: [{
            key: '',
            value: '',
        }],
    }],
});
const changedContact = ref({
    boxList: []
})

const infoBoxVisble = ref(false);
const okHandel = () => {
    isLoading.value = true;
    return postCancelTransaction(regiNo.value)
    .then(() => {
        openPopup('已完成取消預約申請', () => {
            router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_HOME });
        })
        canCancel.value = false;
        canVideo.value = false;        
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};

const thousandthsFormat = (value) => {
    const regex = /\B(?=(\d{3})+(?!\d))/g
    value = value.toString()
    return value.replace(regex, ',')
}

onMounted(() => {
    postCecRecord(regiNo.value).then(res => {

        record.value.boxList = convertCaseBoxList(res.data, loanField.record);
        const a = res.data.pon4300.after;
        accountInfo.value = {
            key: '銀行帳號',
            value: `${a.bank.bankNo} ${a.bank.bankName} <br>${a.bank.bankAccount}`,
        };

        moneyInfo.value = {
            key: '共欲借款總金額',
            value: `$${thousandthsFormat(a?.totalAmount)}`,
            flexClass: 'justify-between',
        };
        a.pon4300ResultDataList.forEach(p => {
            caseItemList.value.push({
                boxList: [
                    {
                        title: `${p.item} ${p.itemName}`,
                        subTitle: `${p.fullPolicyNo}`,
                        iconTitle: '',
                        flexClass: '',
                        list: [
                            {
                                key: '本月利率（年利率）',
                                value: `${p.loanRate}%`,
                            },
                            {
                                key: '借款幣別',
                                value: `${a.currencyText}`,
                            },
                            {
                                key: '借款金額',
                                value: `$${thousandthsFormat(p.amount)}`,
                            },
                        ],
                    },
                ],
            });
        });
        canCancel.value = res.data.canCancel;
        canVideo.value = res.data.canVideo;
        endoresmentContent.value.boxList[0].list[0].value = res.data?.endorsementDesc;
        if (res.data.pon4300?.insMobile) {
            changedContact.value.boxList.push({
                title: '要保人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data.pon4300?.insMobile?.mobile
                }]
            })
        }
        // if (res.data.pon4300?.insuredMobile) {
        //     changedContact.value.boxList.push({
        //         title: '被保險人行動電話',
        //         list: [{
        //             key: '行動電話',
        //             value: res.data.pon4300?.insuredMobile?.mobile
        //         }]
        //     })
        // }
    }).catch(ex => {
        console.log(ex);
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
});
</script>

<template>
    <div>

        <!-- 保單借款 -->
        <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

            <div class="pt-2 pb-6">
                <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證']" :index="1"></Process>
            </div>

            <div class="pb-6">
                <h2 class="pb-3 text-2xl font-bold">
                    申請紀錄
                </h2>
                <CaseBox :caseBox="record" />
            </div>

            <h2 class="pb-3 text-2xl font-bold">
                申請明細
            </h2>

            <div class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    匯款帳號
                </h3>
                <CaseBox :caseBox="accountInfo"></CaseBox>
            </div>

            <div>
                <h3 class="pb-4 text-xl font-bold">
                    借款明細
                </h3>
                <CaseBox :caseBox="moneyInfo"></CaseBox>
                <CaseBox :caseBox="caseBox" :key="i" v-for="(caseBox, i) in caseItemList"></CaseBox>
            </div>

            <div v-if="changedContact.boxList.length > 0" class="pb-2">
                <CaseBox :caseBox="changedContact" />
            </div>

            <div class="pb-2" v-if="!endoresStatus">
                <CaseBox :caseBox="endoresmentContent" />
            </div>

            <div v-if="canCancel" class="text-center">
                <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請
                </button>
            </div>

            <template v-slot:bottom>
                <button
                    class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    :class="canVideo ? '' : 'bg-gray-300'" @click="goNextPage">開始視訊
                </button>
            </template>
            <Loading :is-loading="isLoading" />
        </Layout>

        <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？"
            type="confirm" :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />
    </div>
</template>

<style scoped></style>
